import { tv } from "../foundations/cn.js";
import { CARD_INTERACTIVE, FOCUS_RING } from "../foundations/interaction.js";

/**
 * The card surface every card and page region draws on: the theme's surface fill and edge at one
 * of four radius tiers. Usable on any element (`<li className={cardStyles({ radius: "xl" })}>`)
 * where `Card` can't be the root. Layout and padding stay the caller's.
 */
export const cardStyles = tv({
  base: "bg-bg-surface",
  variants: {
    radius: {
      /** A compact card in a dense rail or list: a pull in a strip, a note. */
      lg: "rounded-lg",
      /** One item or a small summary: an item card, a stat. */
      xl: "rounded-xl",
      /** A card that summarizes one thing (a box, a battle, a review), or a page region. */
      "2xl": "rounded-2xl",
      /** The one region a page is built around: sign-in, the box page's stage, a closing band. */
      "3xl": "rounded-3xl",
    },
    fill: {
      surface: "",
      /** One step above the surface, for a card that sits on another card. */
      raised: "bg-bg-raised",
      /** No fill: a placeholder drawn by its edge alone. */
      none: "bg-transparent",
    },
    edge: {
      /** The theme's surface edge and shadow. */
      default: "surface-edge",
      /** Chosen: the accent edge over the accent's subtle fill. */
      selected: "border border-accent-default bg-accent-subtle",
      /** A place for something not there yet: an open seat, an empty slot. */
      dashed: "border border-border-default border-dashed",
      none: "",
    },
    action: {
      /** Static: nothing on the card acts. */
      none: "",
      /** A `CardLink` on the card's name stretches over it; the card shows its hover and focus. */
      link: ["relative", CARD_INTERACTIVE],
      /** The card is itself a button. */
      button: [CARD_INTERACTIVE, "cursor-pointer text-left", FOCUS_RING],
    },
    hover: {
      none: "",
      /**
       * The fill steps up to the raised surface under the pointer, at once (colors never animate;
       * only the press's scale does): for a card whose fill is most of what you see (a product, a
       * battle row). A card whose fill means something (a picked item's accent) leaves it off and
       * relies on its action's edge.
       */
      raise: "hover:bg-bg-raised",
    },
  },
  defaultVariants: {
    radius: "2xl",
    fill: "surface",
    edge: "default",
    action: "none",
    hover: "none",
  },
});
